module.exports = __webpack_public_path__ + "img/no-time-slot.9ae8734b.svg";